import { FC, useCallback, useContext, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { CommonContext } from '@repo-level/core-front';

import { Button } from 'components/buttons';
import { ModalsContext, ModalType } from 'contexts/modal';
import { TabBarContext } from 'contexts/tabBarSize';

import { ScCookie, ScCookieProps, ScLink } from './styled';
import {
  localStorageIsStag,
  localStorageSpecialStag,
} from 'modules/userTrackingParams';
export interface CookieProps extends ScCookieProps {
  onClose: () => void;
}

export const Cookie: FC<CookieProps> = ({ onClose, ...props }) => {
  const { t } = useTranslation('common');

  const { currentIp } = useContext(CommonContext);
  const { handleModal } = useContext(ModalsContext);

  const isAUCookies = useMemo(
    () =>
      currentIp?.countryCode === 'AU' &&
      !(localStorageIsStag.get() || localStorageSpecialStag.get()),
    [currentIp?.countryCode]
  );

  const handlePrivacy = useCallback(
    () => handleModal(ModalType.PrivacyPolicy)(),
    [handleModal]
  );

  const { tabBarHeight } = useContext(TabBarContext);

  const cookieText = useMemo(
    () =>
      isAUCookies ? (
        <Trans i18nKey="common:cookie.AUText">
          We use <ScLink onClick={handlePrivacy}>Cookie Policy</ScLink>. Also in
          proceeding I confirm that I am currently accessing this website from
          outside of Australia.
        </Trans>
      ) : (
        <Trans i18nKey="common:cookie.defaultText">
          We use cookies to improve your experience. By using our website you
          are accepting our
          <ScLink onClick={handlePrivacy}>Cookie Policy</ScLink>
        </Trans>
      ),
    [isAUCookies, handlePrivacy]
  );

  return (
    <ScCookie bottom={tabBarHeight}>
      <div className="text">{cookieText}</div>
      <Button blue medium _width={107} onClick={onClose}>
        {t('glossary:continue')}
      </Button>
    </ScCookie>
  );
};
